import { AxiosPromise } from 'axios';
import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { IStorageSummary } from './interfaces';

const basePath = '/storageMetrics';

export const getStorageMetricsByUser = (): AxiosPromise<IApiResponse<IStorageSummary>> => vaultApi.getInstance().get(`${basePath}/getByUser`);

export const getStorageMetricsByCustomer = (id: string): AxiosPromise<IApiResponse<IStorageSummary>> => vaultApi.getInstance().get(`${basePath}/getByCustomer/${id}`);
